import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isRead: false,
  notificationId: 0,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    clearNotification: (_state) => initialState,
    setNotificationId(state, { payload }) {
      return {
        ...state,
        notificationId: payload,
      };
    },
    setNotificationIsRead(state, { payload }) {
      return {
        ...state,
        isRead: payload,
      };
    },
  },
});

export const { clearNotification, setNotificationId, setNotificationIsRead } = notificationSlice.actions;
export default notificationSlice.reducer;
